import { Cell, State } from "./types";

export const clearSelectedBorders = (cells: State["cells"]): State["cells"] =>
  cells.reduce((prev: Array<Cell>, next: Cell, index: number): Array<Cell> => {
    if (next.selectedBorder === null) {
      return prev;
    }
    const newCell = { ...next, selectedBorder: null };
    if (prev === cells) {
      return [...prev.slice(0, index), newCell, ...prev.slice(index + 1)];
    }
    prev[index] = newCell;
    return prev;
  }, cells as Array<Cell>);
